import { render } from "./goodsInfo.vue?vue&type=template&id=09958f67&scoped=true"
import script from "./goodsInfo.vue?vue&type=script&lang=js"
export * from "./goodsInfo.vue?vue&type=script&lang=js"

import "./goodsInfo.vue?vue&type=style&index=0&id=09958f67&scoped=true&lang=css"

import exportComponent from "/home/LiuJing/code/MyProjects/YiZhiWang/yizhiwang_web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09958f67"]])

export default __exports__